<template>
  <div v-if="renderReady">
    <b-form-group :label="getTitle">
      <v-select v-model="selectedValue" label="text" :options="values" :multiple="multiple" :taggable="taggable">
        <template v-slot:spinner="slotProps">
          <div class="spinner" v-show="slotProps.mutableLoading">Ładowanie...</div>
        </template>
        <template v-slot:no-options>
          <div>Nie znaleziono wyników.</div>
        </template>
      </v-select>
    </b-form-group>

    <w-error :model="model"></w-error>
  </div>
</template>

<script>
import modelMixin from '@/mixins/modelMixin';
import WError from './error.vue';

export default {
  components: { WError },
  mixins: [modelMixin],
  props: {
    values: Array,
    placeholder: String,
    multiple: Boolean,
    taggable: Boolean
  },
  data() {
    return {
      sid: 'ddw' + Math.round(Math.random() * 1000000),
      selectedValue: this.modelValue()
    };
  },
  methods: {
    modelValue() {
      if (!this.model.$model) {
        return this.multiple ? [] : null;
      }
      if (this.multiple) {
        return this.values.filter(val => this.model.$model.includes(val.value || val));
      }
      return this.values.find(val => (val.value || val) === this.model.$model);
    }
  },
  watch: {
    selectedValue(newValue) {
      if (newValue) {
        this.model.$model = this.multiple ? newValue.map(item => item.value || item) : newValue.value;
      } else if (this.values) {
        this.model.$model = this.multiple ? [] : null;
      }
    },
    values() {
      this.$set(this, 'selectedValue', this.modelValue());
    }
  }
};
</script>
